// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Color definitions for the app
 */

.DuplicateIDModal .alert-circle-icon {
  display: flex;
  position: relative;
  width: 48px;
  height: 48px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  border-radius: 28px;
  border: 8px solid rgba(255, 193, 7, 0.5);
  background: #FFC107;
  margin-bottom: 16px;
}
.DuplicateIDModal .alert-circle-icon svg {
  position: relative;
  top: -5px;
  left: -5px;
}
.DuplicateIDModal .external-delete-title {
  color: #101828;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px; /* 155.556% */
  margin-bottom: 16px;
}
.DuplicateIDModal .external-delete-text {
  color: #667085;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 142.857% */
  margin-bottom: 32px;
}
.DuplicateIDModal .external-duplicates-list {
  display: flex;
  align-items: center;
  flex-basis: 100%;
  flex-wrap: wrap;
}
.DuplicateIDModal .external-duplicates-row {
  display: flex;
  align-items: center;
  flex-basis: 100%;
  margin-bottom: 16px;
}
.DuplicateIDModal .external-duplicates-source {
  display: flex;
  height: 34px;
  font-size: 12px;
  padding-left: 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  flex-basis: 46%;
  border-radius: 4px;
  border: 1px solid #D0D5DD;
  background: #F9FAFB;
  color: #667085;
  text-transform: capitalize;
  width: 46%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
  /* Shadow/xs */
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
}
.DuplicateIDModal .external-duplicates-extid {
  height: 34px;
  font-size: 12px;
  padding-left: 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  flex-basis: 46%;
  margin-left: 16px;
  border-radius: 4px;
  border: 1px solid #D0D5DD;
  background: #F9FAFB;
  width: 46%;
  line-height: 36px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
  padding-right: 8px;
  /* Shadow/xs */
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
}
.DuplicateIDModal .duplicate-cancel-btn {
  height: 38px;
  width: 100%;
}
.DuplicateIDModal .id-delete-btn {
  height: 38px;
  width: calc(50% - 5px);
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/sass/color.scss","webpack://./src/web/client/src/components/Locations/IndividualLocation/EditLocation/Profile/Sections/DuplicateIDModal.scss"],"names":[],"mappings":"AAAA;;EAAA;;ACII;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wCAAA;EACA,mBDIE;ECHF,mBAAA;AAqFR;AAlFI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;AAoFR;AAjFI;EACI,cD4DE;EC3DF,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,mBAAA;AAmFR;AAhFI;EACI,cDiDE;EChDF,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,mBAAA;AAkFR;AA/EI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAiFR;AA9EI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAgFR;AA7EI;EACI,aAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBDYC;ECXD,cDeE;ECdF,0BAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EAEA,cAAA;EACA,8CAAA;AA8ER;AA3EI;EACI,YAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBDZC;ECaD,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EAEA,cAAA;EACA,8CAAA;AA4ER;AAzEI;EACI,YAAA;EACA,WAAA;AA2ER;AAxEI;EACI,YAAA;EACA,sBAAA;AA0ER","sourcesContent":["/**\n * Color definitions for the app\n */\n\n// Theme Colors\n$primary: #333F48;\n$secondary: #222732;\n$yellow: #FECF0C;\n$red: #E02D4F;\n$teal: #23CCC3;\n$orange: #F66733;\n$lightGray: #F6F6F6;\n$whiteSmoke: #E1E1E9;\n$manatee: #959AAD;\n$obsidian: #383838;\n\n// Status Colors\n$success: #00A474;\n$warning: #FFC107;\n$error: #CF0838;\n\n// Other Colors\n$white: #FFFFFF;\n$black: #000000;\n$gray: #757575;\n$darkGray: #A4A7B7;\n$mediumGray: #E0E0E0;\n$lighterGray: #E3E7F4;\n$lightSlateGray: #8A8FA3;\n$carrot: #FF892E;\n$lightSmoke: #F5F4F5;\n$graphBlue: #1570EF;\n$lightOrchid: #7F56D9;\n$rainboots: #3361E1;\n$royalBlue: #4085DE;\n$sushi: #95C653;\n\n// Component Colors\n$primaryButtonBackground: $yellow;\n$primaryButtonText: $primary;\n$secondaryButtonBackground: $primary;\n$secondaryButtonText: $white;\n$navigationText: #95A3AD;\n$scheduleMusic: #FCC7B3;\n$scheduleMessageBlock: $teal;\n$scheduleInterrupt: #1997A3;\n$scheduleLoop: $primary;\n\n// Variants: Theme Colors\n$primary16: rgba($primary, 0.16);\n$primary40: rgba($primary, 0.4);\n$primary50: rgba($primary, 0.5);\n$primary60: rgba($primary, 0.6);\n$secondary25: rgba($secondary, 0.25);\n$secondary50: rgba($secondary, 0.5);\n$secondary75: rgba($secondary, 0.75);\n$yellow16: rgba($yellow, 16%);\n$yellow25: rgba($yellow, 25%);\n$yellow75: rgba($yellow, 75%);\n$orange16: rgba($orange, 0.16);\n$orange32: rgba($orange, 0.32);\n$orange50: rgba($orange, 0.5);\n$orange75: rgba($orange, 0.75);\n$manatee16: rgba($manatee, 0.16);\n$manatee50: rgba($manatee, 0.5);\n\n// Variants: Status Colors\n$success10: rgba($success, 0.08);\n$success16: rgba($success, 0.16);\n$success75: rgba($success, 0.75);\n$warning50: rgba($warning, 0.5);\n$error10: rgba($error, 0.1);\n$error16: rgba($error, 0.16);\n$error20: rgba($error, 0.2);\n$error50: rgba($error, 0.5);\n$error75: rgba($error, 0.75);\n$error85: rgba($error, 0.85);\n\n// Variants: Other Colors\n$gray50: #F9FAFB;\n$gray200: #EAECF0;\n$gray300: #D0D5DD;\n$gray400: #98A2B3;\n$gray500: #667085;\n$gray700: #344054;\n$gray900: #101828;\n$carrot16: rgba($carrot, 0.16);\n$rainboots16: rgba($rainboots, 0.16);\n$royalBlue16: rgba($royalBlue, 0.16);\n\n// Box colors (for color picker)\n$boxRed: $red;\n$boxPink: #F57A7A;\n$boxOrange: $orange;\n$boxYellow: $yellow;\n$boxGreen: #95C653;\n$boxDarkGreen: #00A474;\n$boxBlue: #33ACE1;\n$boxDarkBlue: #3361E1;\n$boxPurple: #6D6DB5;\n$boxDarkPurple: #332A4B;\n\n:export {\n  // Theme Colors\n  primary: $primary;\n  secondary: $secondary;\n  yellow: $yellow;\n  red: $red;\n  teal: $teal;\n  orange: $orange;\n  lightGray: $lightGray;\n  whiteSmoke: $whiteSmoke;\n  manatee: $manatee;\n  obsidian: $obsidian;\n\n  // Status Colors\n  success: $success;\n  warning: $warning;\n  error: $error;\n\n  // Other Colors\n  white: $white;\n  black: $black;\n  gray: $gray;\n  darkGray: $darkGray;\n  mediumGray: $mediumGray;\n  lighterGray: $lighterGray;\n  lightSlateGray: $lightSlateGray;\n  carrot: $carrot;\n  lightSmoke: $lightSmoke;\n  graphBlue: $graphBlue;\n  lightOrchid: $lightOrchid;\n  rainboots: $rainboots;\n  royalBlue: $royalBlue;\n  sushi: $sushi;\n\n  // Component Colors\n  primaryButtonBackground: $primaryButtonBackground;\n  primaryButtonText: $primaryButtonText;\n  secondaryButtonBackground: $secondaryButtonBackground;\n  secondaryButtonText: $secondaryButtonText;\n  navigationText: $navigationText;\n  scheduleMusic: $scheduleMusic;\n  scheduleMessageBlock: $scheduleMessageBlock;\n  scheduleInterrupt: $scheduleInterrupt;\n  scheduleLoop: $scheduleLoop;\n  \n  // Variants: Theme Colors\n  primary16: $primary16;\n  primary40: $primary40;\n  primary50: $primary50;\n  primary60: $primary60;\n  secondary25: $secondary25;\n  secondary50: $secondary50;\n  secondary75: $secondary75;\n  yellow16: $yellow16;\n  yellow25: $yellow25;\n  yellow75: $yellow75;\n  orange16: $orange16;\n  orange32: $orange32;\n  orange50: $orange50;\n  orange75: $orange75;\n  manatee16: $manatee16;\n  manatee50: $manatee50;\n\n  // Variants: Status Colors\n  success10: $success10;\n  success16: $success16;\n  success75: $success75;\n  warning50: $warning50;\n  error10: $error10;\n  error16: $error16;\n  error20: $error20;\n  error50: $error50;\n  error75: $error75;\n  error85: $error85;\n\n  // Variants: Other Colors\n  gray50: $gray50;\n  gray200: $gray200;\n  gray300: $gray300;\n  gray400: $gray400;\n  gray500: $gray500;\n  gray700: $gray700;\n  gray900: $gray900;\n  carrot16: $carrot16;\n  rainboots16: $rainboots16;\n  royalBlue16: $royalBlue16;\n\n  // Box colors (for color picker)\n  boxRed: $boxRed;\n  boxPink: $boxPink;\n  boxOrange: $boxOrange;\n  boxYellow: $boxYellow;\n  boxGreen: $boxGreen;\n  boxDarkGreen: $boxDarkGreen;\n  boxBlue: $boxBlue;\n  boxDarkBlue: $boxDarkBlue;\n  boxPurple: $boxPurple;\n  boxDarkPurple: $boxDarkPurple;\n}\n","@use '~vibeguide/sass/color.scss' as color;\n\n.DuplicateIDModal {\n    \n    .alert-circle-icon {\n        display: flex;\n        position: relative;\n        width: 48px;\n        height: 48px;\n        padding: 12px;\n        justify-content: center;\n        align-items: center;\n        border-radius: 28px;\n        border: 8px solid color.$warning50;\n        background: color.$warning;\n        margin-bottom: 16px;\n    }\n\n    .alert-circle-icon svg {\n        position: relative;\n        top: -5px;\n        left: -5px;\n    }\n\n    .external-delete-title {\n        color: color.$gray900;\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 28px; /* 155.556% */\n        margin-bottom: 16px;\n    }\n\n    .external-delete-text {\n        color: color.$gray500;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 18px; /* 142.857% */\n        margin-bottom: 32px;\n    }\n\n    .external-duplicates-list {\n        display: flex;\n        align-items: center;\n        flex-basis: 100%;\n        flex-wrap: wrap;\n    }\n\n    .external-duplicates-row {\n        display: flex;\n        align-items: center;\n        flex-basis: 100%;\n        margin-bottom: 16px;\n    }\n\n    .external-duplicates-source {\n        display: flex;\n        height: 34px;\n        font-size: 12px;\n        padding-left: 8px;\n        align-items: center;\n        gap: 8px;\n        align-self: stretch;\n        flex-basis: 46%;\n        border-radius: 4px;\n        border: 1px solid color.$gray300;\n        background: color.$gray50;\n        color: color.$gray500;\n        text-transform: capitalize;\n        width: 46%;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        min-width: 0;\n\n        /* Shadow/xs */\n        box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);\n    }\n\n    .external-duplicates-extid {\n        height: 34px;\n        font-size: 12px;\n        padding-left: 8px;\n        align-items: center;\n        gap: 8px;\n        align-self: stretch;\n        flex-basis: 46%;\n        margin-left: 16px;\n        border-radius: 4px;\n        border: 1px solid color.$gray300;\n        background: color.$gray50;\n        width: 46%;\n        line-height: 36px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        min-width: 0;\n        padding-right: 8px;\n\n        /* Shadow/xs */\n        box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);\n    }\n\n    .duplicate-cancel-btn {\n        height: 38px;\n        width: 100%;\n    }\n\n    .id-delete-btn {\n        height: 38px;\n        width: calc(50% - 5px);\n    }\n    \n}\n\n "],"sourceRoot":""}]);
// Exports
export var primary = `#333F48`;
export var secondary = `#222732`;
export var yellow = `#FECF0C`;
export var red = `#E02D4F`;
export var teal = `#23CCC3`;
export var orange = `#F66733`;
export var lightGray = `#F6F6F6`;
export var whiteSmoke = `#E1E1E9`;
export var manatee = `#959AAD`;
export var obsidian = `#383838`;
export var success = `#00A474`;
export var warning = `#FFC107`;
export var error = `#CF0838`;
export var white = `#FFFFFF`;
export var black = `#000000`;
export var gray = `#757575`;
export var darkGray = `#A4A7B7`;
export var mediumGray = `#E0E0E0`;
export var lighterGray = `#E3E7F4`;
export var lightSlateGray = `#8A8FA3`;
export var carrot = `#FF892E`;
export var lightSmoke = `#F5F4F5`;
export var graphBlue = `#1570EF`;
export var lightOrchid = `#7F56D9`;
export var rainboots = `#3361E1`;
export var royalBlue = `#4085DE`;
export var sushi = `#95C653`;
export var primaryButtonBackground = `#FECF0C`;
export var primaryButtonText = `#333F48`;
export var secondaryButtonBackground = `#333F48`;
export var secondaryButtonText = `#FFFFFF`;
export var navigationText = `#95A3AD`;
export var scheduleMusic = `#FCC7B3`;
export var scheduleMessageBlock = `#23CCC3`;
export var scheduleInterrupt = `#1997A3`;
export var scheduleLoop = `#333F48`;
export var primary16 = `rgba(51, 63, 72, 0.16)`;
export var primary40 = `rgba(51, 63, 72, 0.4)`;
export var primary50 = `rgba(51, 63, 72, 0.5)`;
export var primary60 = `rgba(51, 63, 72, 0.6)`;
export var secondary25 = `rgba(34, 39, 50, 0.25)`;
export var secondary50 = `rgba(34, 39, 50, 0.5)`;
export var secondary75 = `rgba(34, 39, 50, 0.75)`;
export var yellow16 = `rgba(254, 207, 12, 0.16)`;
export var yellow25 = `rgba(254, 207, 12, 0.25)`;
export var yellow75 = `rgba(254, 207, 12, 0.75)`;
export var orange16 = `rgba(246, 103, 51, 0.16)`;
export var orange32 = `rgba(246, 103, 51, 0.32)`;
export var orange50 = `rgba(246, 103, 51, 0.5)`;
export var orange75 = `rgba(246, 103, 51, 0.75)`;
export var manatee16 = `rgba(149, 154, 173, 0.16)`;
export var manatee50 = `rgba(149, 154, 173, 0.5)`;
export var success10 = `rgba(0, 164, 116, 0.08)`;
export var success16 = `rgba(0, 164, 116, 0.16)`;
export var success75 = `rgba(0, 164, 116, 0.75)`;
export var warning50 = `rgba(255, 193, 7, 0.5)`;
export var error10 = `rgba(207, 8, 56, 0.1)`;
export var error16 = `rgba(207, 8, 56, 0.16)`;
export var error20 = `rgba(207, 8, 56, 0.2)`;
export var error50 = `rgba(207, 8, 56, 0.5)`;
export var error75 = `rgba(207, 8, 56, 0.75)`;
export var error85 = `rgba(207, 8, 56, 0.85)`;
export var gray50 = `#F9FAFB`;
export var gray200 = `#EAECF0`;
export var gray300 = `#D0D5DD`;
export var gray400 = `#98A2B3`;
export var gray500 = `#667085`;
export var gray700 = `#344054`;
export var gray900 = `#101828`;
export var carrot16 = `rgba(255, 137, 46, 0.16)`;
export var rainboots16 = `rgba(51, 97, 225, 0.16)`;
export var royalBlue16 = `rgba(64, 133, 222, 0.16)`;
export var boxRed = `#E02D4F`;
export var boxPink = `#F57A7A`;
export var boxOrange = `#F66733`;
export var boxYellow = `#FECF0C`;
export var boxGreen = `#95C653`;
export var boxDarkGreen = `#00A474`;
export var boxBlue = `#33ACE1`;
export var boxDarkBlue = `#3361E1`;
export var boxPurple = `#6D6DB5`;
export var boxDarkPurple = `#332A4B`;
export default ___CSS_LOADER_EXPORT___;
